export var CART_CHECKOUT_QUERYNAME = 'commerce1ClickCartCheckoutLocaleCollection';
export var ORDER_MANAGEMENT_QUERYNAME = 'commerce1ClickOrderManagementLocaleCollection';
export var PLAN_SELECTION_QUERYNAME = 'commerce1ClickPlanSelectionLocaleCollection';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/constants/graphql.js
// module id = 485
// module chunks = 11